webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isLoading: true,
      settings: null
    };
  },
  mounted: function mounted() {
    this.isLoading = false;

    if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
    if (this.settings == null || this.settings.myWeight === null) {
      // this.$router.push({name: 'setWeight', params: {myWeight:this.myWeight}})
      this.$router.push({ name: 'setWeight' });
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_otherComponents_totalBar__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_otherComponents_setDefaultDrink__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_otherComponents_addDrink__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_otherComponents_drunkDrinks__ = __webpack_require__(332);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainView',
  components: { total: __WEBPACK_IMPORTED_MODULE_3__components_otherComponents_totalBar__["a" /* default */], setDefaultDrink: __WEBPACK_IMPORTED_MODULE_4__components_otherComponents_setDefaultDrink__["a" /* default */], addDrink: __WEBPACK_IMPORTED_MODULE_5__components_otherComponents_addDrink__["a" /* default */], drunkDrinks: __WEBPACK_IMPORTED_MODULE_6__components_otherComponents_drunkDrinks__["a" /* default */] },
  data: function data() {
    return {
      // water: 0,
      // myWeight: null,
      settings: null,
      // limit: 0,
      defaultDrink: 1,
      showSetDefaultMenu: false,
      availableDrinks: [{
        id: 1,
        name: "Woda",
        size: 200,
        active: true
      }],
      drunkHistory: [{
        id: 1,
        drinkId: 1,
        dateTime: new Date(),
        size: 200,
        active: true
      }]
    };
  },

  computed: {
    getDefaultDrinkProps: function getDefaultDrinkProps() {
      var _this = this;

      return this.availableDrinks.find(function (obj) {
        return obj.id === _this.defaultDrink;
      });
    },

    getDrunkHistoryToday: {
      set: function set(val) {
        this.drunkHistory = val;
        // this.createRecord("drunkHistory", this.drunkHistory)
      },
      get: function get() {
        // console.log(this.drunkHistory)
        // if (this.drunkHistory) {
        // return this.drunkHistory.then((value) => {
        return this.drunkHistory.filter(function (key) {
          return __WEBPACK_IMPORTED_MODULE_2_moment___default()(key.dateTime).isSame(new Date(), "day");
        });
        // })
        // } else {
        //   return []
        // }
      }
    },
    getActiveAvailableDrinks: function getActiveAvailableDrinks() {
      return this.availableDrinks.filter(function (key) {
        return key.active !== false;
      });
    },
    getNewIdDrunkHistory: function getNewIdDrunkHistory() {
      var max = 0;
      this.getDrunkHistoryToday.forEach(function (el) {
        if (el.id > max) {
          max = el.id;
        }
      });
      return max + 1;
    },
    limit: function limit() {
      // set(val) {
      //   localStorage.setItem('limit', JSON.stringify(this.limit));
      // },
      // get() {
      console.log(this.settings);
      if (this.settings !== null) {
        var sum = Math.round(this.settings.myWeight * 0.043 * 1000);
        if (this.settings.sunny) {
          sum += 250;
        }
        if (this.settings.sport) {
          sum += 250;
        }
        return sum;
      }
      // }
    },
    showLessHistory: function showLessHistory() {
      if (this.settings !== null) {

        return this.settings.lessHistory;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
    // if (localStorage.getItem('sport')) this.sport = JSON.parse(localStorage.getItem('sport'));
    // if (localStorage.getItem('sunny')) this.sunny = JSON.parse(localStorage.getItem('sunny'));

    if (localStorage.getItem('drunkHistory')) this.drunkHistory = JSON.parse(localStorage.getItem('drunkHistory'));
    if (localStorage.getItem('availableDrinks')) this.availableDrinks = JSON.parse(localStorage.getItem('availableDrinks'));
    if (localStorage.getItem('showSetDefaultMenu')) this.showSetDefaultMenu = JSON.parse(localStorage.getItem('showSetDefaultMenu'));
    if (localStorage.getItem('defaultDrink')) this.defaultDrink = JSON.parse(localStorage.getItem('defaultDrink'));
    // if (localStorage.getItem('limit')) this.limit = JSON.parse(localStorage.getItem('limit'));

    // this.setLimit()
  },

  watch: {
    drunkHistory: {
      handler: function handler() {
        console.log('drunkHistory changed!');
        localStorage.setItem('drunkHistory', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.drunkHistory));
      },

      deep: true
    },
    availableDrinks: {
      handler: function handler() {
        console.log('availableDrinks changed!');
        localStorage.setItem('availableDrinks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.availableDrinks));
      },

      deep: true
    },
    showSetDefaultMenu: {
      handler: function handler() {
        console.log('showSetDefaultMenu changed!');
        localStorage.setItem('showSetDefaultMenu', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.showSetDefaultMenu));
      },

      deep: true
    },
    defaultDrink: {
      handler: function handler() {
        console.log('defaultDrink changed!');
        localStorage.setItem('defaultDrink', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.defaultDrink));
      },

      deep: true
    }
    // limit: {
    //   handler() {
    //     console.log('limit changed!');
    //     localStorage.setItem('limit', JSON.stringify(this.limit));
    //   },
    //   deep: true,
    // },
  },
  methods: {
    addDrink: function addDrink() {
      var _this2 = this;

      var drinkSize = this.availableDrinks.find(function (obj) {
        return obj.id === _this2.defaultDrink;
      }).size;
      console.log("add drink: ", drinkSize);
      console.log("Drunk history: ", this.drunkHistory);
      console.log("Drunk history length: ", this.drunkHistory.length + 1);
      // this.drunkHistory.push({id: this.getNewIdDrunkHistory, drinkId: this.defaultDrink, dateTime: moment().subtract(10, 'days'), size: drinkSize, active: true})
      this.drunkHistory.push({ id: this.getNewIdDrunkHistory, drinkId: this.defaultDrink, dateTime: __WEBPACK_IMPORTED_MODULE_2_moment___default()(), size: drinkSize, active: true });
      // this.createRecord("drunkHistory", this.drunkHistory)
    },
    setDefaultDrink: function setDefaultDrink(drinkId) {
      console.log("set default drink:", drinkId);
      this.defaultDrink = drinkId;
      this.showSetDefaultMenu = false;
      // this.createRecord("defaultDrink", this.defaultDrink)
    },
    saveEditDrinkTemplate: function saveEditDrinkTemplate(editedItem) {
      console.log("EDIT ", editedItem);
      // this.availableDrinks = [{}];
      console.log(editedItem.template);
      this.availableDrinks[this.availableDrinks.findIndex(function (el) {
        return el.id === editedItem.id;
      })] = editedItem.template;

      // notify about change! fix save to localStorage ;(
      this.availableDrinks.__ob__.dep.notify();
    },
    deleteEditDrinkTemplate: function deleteEditDrinkTemplate(editedItem) {
      console.log("DELETE ", editedItem);
      // this.availableDrinks = [{}];
      console.log(editedItem.id);
      this.availableDrinks[this.availableDrinks.findIndex(function (el) {
        return el.id === editedItem.id;
      })].active = false;

      // notify about change! fix save to localStorage ;(
      this.availableDrinks.__ob__.dep.notify();

      if (this.getActiveAvailableDrinks.length > 0) {
        this.defaultDrink = this.getActiveAvailableDrinks[0].id || null;
      } else {
        this.defaultDrink = null;
      }
    },
    addOwnDrink: function addOwnDrink(properties) {
      console.log("JEST");
      var newDrinkId = this.availableDrinks.length + 1;
      console.log("New drink ID ", newDrinkId);
      this.availableDrinks.push({ id: newDrinkId, name: properties.name, size: properties.size, active: true });
      // this.createRecord("availableDrinks", this.availableDrinks)
      this.setDefaultDrink(newDrinkId);
    },
    saveEditDialog: function saveEditDialog(properties) {
      console.log("NEW SIZE: ", properties);
      this.getDrunkHistoryToday.find(function (obj) {
        return obj.id == properties.id;
      }).size = properties.newSize;
    },
    deleteEditDialog: function deleteEditDialog(id) {
      this.getDrunkHistoryToday = this.getDrunkHistoryToday.filter(function (el) {
        return el.id !== id;
      });
      // this.getDrunkHistoryToday.remove((obj)=>{return obj.id == id});
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'totalBar',
  props: ['drunkHistory', 'limit'],
  data: function data() {
    return {};
  },

  computed: {
    currentState: function currentState() {
      var drunk = 0;
      // console.log("s", this.drunkHistory)

      // this.drunkHistory.then((value) => {
      this.drunkHistory.forEach(function (drink) {
        if (drink.active) {
          drunk += parseInt(drink.size);
        }
      });
      // })


      return drunk;
    },
    total: function total() {
      return this.currentState / this.limit * 100;
    }
  },
  methods: {
    goToSetWeight: function goToSetWeight() {
      this.$router.push({ name: 'setWeight' });
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_otherComponents_addOwnDrink__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_otherComponents_editDrink__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'setDefaultDrink',
  components: { addOwnDrink: __WEBPACK_IMPORTED_MODULE_1__components_otherComponents_addOwnDrink__["a" /* default */], editDrink: __WEBPACK_IMPORTED_MODULE_2__components_otherComponents_editDrink__["a" /* default */] },
  props: ['availableDrinks', 'defaultDrink'],
  data: function data() {
    return {
      sheet: false,
      editDialog: false,
      currentEditTemplate: {
        name: "",
        size: 0
      },
      successSnack: false,
      formValid: true,
      rules: {
        required: function required(value) {
          return !!value || 'Niestety, to pole jest wymagane :(';
        }
      }
    };
  },

  computed: {
    availableDrinksSorted: function availableDrinksSorted() {
      return _.orderBy(this.availableDrinks, 'size', 'asc');
    }
  },
  methods: {
    setDefaultDrink: function setDefaultDrink(drinkId) {
      this.sheet = false;
      this.$emit('setDefaultDrink', drinkId);
      // this.successSnack = true;
    },
    saveOwnDrink: function saveOwnDrink(properties) {
      // console.log("MAMY ZMIANKE")
      // if (this.$refs.setDefaultDrinkForm.validate()) {

      this.$emit('addOwnDrink', properties);

      // console.log(properties)
      // }else{
      //   console.log(properties)
      //   console.log(this.$refs.setDefaultDrinkForm)
      //   console.log(this.$refs.setDefaultDrinkForm.validate())
      //   console.log("niewalidate")
      // }
      // this.successSnack = true;
    },
    openEditTemplate: function openEditTemplate(template) {
      console.log("Open", template);
      this.currentEditTemplate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template);
      this.editDialog = true;
    },
    saveEditDrinkTemplate: function saveEditDrinkTemplate(template) {
      // console.log(this.$refs.form.validate())
      if (this.formValid) {
        this.$emit('saveEditDrinkTemplate', { id: template.id, template: template });
        this.editDialog = false;
        this.successSnack = true;
      }
    },
    deleteEditDrinkTemplate: function deleteEditDrinkTemplate(template) {
      this.$emit('deleteEditDrinkTemplate', { id: template.id });
      this.editDialog = false;
      this.successSnack = true;
    },
    addOwnDrinkActive: function addOwnDrinkActive() {
      this.sheet = false;
    },
    addOwnDrinkSuccess: function addOwnDrinkSuccess() {
      this.successSnack = true;
    }
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      size: 200,
      name: "",
      formValid: false,
      rules: {
        required: function required(value) {
          return !!value || 'Niestety, to pole jest wymagane :(';
        }
      }
    };
  },

  methods: {
    saveOwnDrink: function saveOwnDrink() {
      this.dialog = false;
      this.$emit('saveOwnDrink', { size: parseInt(this.size), name: this.name });
      this.addOwnDrinkSuccess();
    },
    active: function active() {
      this.dialog = true;
      this.$emit('addOwnDrinkActive');
    },
    addOwnDrinkSuccess: function addOwnDrinkSuccess() {
      this.$emit('addOwnDrinkSuccess');
    }
  }

});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "editDrink",
  data: function data() {
    return {
      dialog: false
    };
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'addDrink',
  props: ['defaultDrink'],
  data: function data() {
    return {};
  },

  methods: {
    addDrink: function addDrink() {
      this.$emit('addDrink');
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drunkDrinks',
  props: ['drunkHistory', 'availableDrinks', 'showLessHistory'],
  data: function data() {
    return {
      dialog: false,
      currentClickedDrink: {},
      successSnack: false
      // _drunkHistory: []
    };
  },
  created: function created() {
    // this._drunkHistory = this.drunkHistory;
    console.log("Less", this.showLessHistory);
  },

  computed: {
    drunkHistoryLast: function drunkHistoryLast() {
      if (this.showLessHistory) {
        return _.orderBy(this.drunkHistory, 'id', 'desc').slice(0, 4);
      } else {
        return _.orderBy(this.drunkHistory, 'id', 'desc');
      }
    }
  },
  methods: {
    getOnlyTime: function getOnlyTime(date) {
      var parseDate = new Date(date);
      var h = (parseDate.getHours() < 10 ? '0' : '') + parseDate.getHours();
      var m = (parseDate.getMinutes() < 10 ? '0' : '') + parseDate.getMinutes();
      return h + ':' + m;
    },
    drinkProperties: function drinkProperties(id) {
      // console.log("=>", id);
      return this.availableDrinks.find(function (obj) {
        // console.log("->", obj);
        return obj.id == id;
      });
    },
    openEditDialog: function openEditDialog(drink) {
      this.currentClickedDrink = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, drink);
      this.dialog = true;
      // console.log("Edit ", this.currentClickedDrink)
    },
    saveEditDialog: function saveEditDialog() {
      this.dialog = false;
      this.$emit('saveEditDialog', { id: this.currentClickedDrink.id, newSize: parseInt(this.currentClickedDrink.size) });
      this.successSnack = true;
    },
    deleteEditDialog: function deleteEditDialog() {
      this.dialog = false;
      this.$emit('deleteEditDialog', this.currentClickedDrink.id);
      this.successSnack = true;
    },
    goToHistory: function goToHistory() {
      this.$router.push({ name: 'fullHistory' });
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'setWeight',
  // props: ['myWeight'],
  data: function data() {
    return {

      myWeightInput: null,
      settings: {
        myWeight: null,
        sport: false,
        sunny: false,
        lessHistory: true
      },
      errorText: false,
      showRedirect: false
    };
  },
  mounted: function mounted() {

    if (localStorage.getItem('settings')) this.settings = JSON.parse(localStorage.getItem('settings'));
    // if (localStorage.getItem('sport')) this.sport = JSON.parse(localStorage.getItem('sport'));
    // if (localStorage.getItem('sunny')) this.sunny = JSON.parse(localStorage.getItem('sunny'));
    this.myWeightInput = this.settings.myWeight;
    console.log("myWeight: ", this.settings.myWeight, this.myWeightInput);
  },

  watch: {
    settings: {
      handler: function handler() {
        console.log('settings changed!');
        localStorage.setItem('settings', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.settings));
      },

      deep: true
    }
    // sport: {
    //   handler() {
    //     console.log('sport changed!');
    //     localStorage.setItem('sport', JSON.stringify(this.sport));
    //   },
    //   deep: true,
    // },
    // sunny: {
    //   handler() {
    //     console.log('sunny changed!');
    //     localStorage.setItem('sunny', JSON.stringify(this.sunny));
    //   },
    //   deep: true,
    // }
  },
  methods: {
    setWeight: function setWeight(weight) {
      if (weight > 0 && weight < 400) {
        this.settings.myWeight = weight;
        this.errorText = false;
        this.showRedirect = true;
      } else {
        this.errorText = "Waga nie może być mniejsza niż 0kg i większa niż 400kg";
      }
    },
    redirectToMainView: function redirectToMainView() {
      this.$router.push({ name: 'mainView' });
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pl');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fullHistory',
  // props: ['myWeight'],
  data: function data() {
    return {
      drunkHistory: [{
        id: 1,
        drinkId: 1,
        dateTime: new Date(),
        size: 200,
        active: true
      }],
      // testDrinks: {
      //   "dzisiaj": [
      //     {
      //       id: 1,
      //       name: "Woda",
      //       size: 200,
      //       active: true,
      //     }
      //   ],
      //   "wczoraj": [
      //     {
      //       id: 1,
      //       name: "Woda",
      //       size: 200,
      //       active: true,
      //     }
      //   ],
      // },
      availableDrinks: [{
        id: 1,
        name: "Woda",
        size: 200,
        active: true
      }]
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem('drunkHistory')) this.drunkHistory = JSON.parse(localStorage.getItem('drunkHistory'));
    if (localStorage.getItem('availableDrinks')) this.availableDrinks = JSON.parse(localStorage.getItem('availableDrinks'));
    console.log(this.historyParsed);
  },

  computed: {
    historyParsed: function historyParsed() {
      var history = {};
      this.drunkHistory.forEach(function (obj) {
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(obj.dateTime).isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'months'), "month")) {
          var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(obj.dateTime).format('LL');
          if (date in history) {
            history[date].push(obj);
          } else {
            history[date] = [];
            history[date].push(obj);
          }
          // console.log()
          console.log(obj);
        }
      });

      console.log(history);
      // if (Object.keys(history).length > 1) {
      //   history = history.reverse()
      // }

      var reverseObj = function reverseObj(object) {
        var NewObj = {},
            keysArr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object);
        for (var i = keysArr.length - 1; i >= 0; i--) {
          NewObj[keysArr[i]] = object[keysArr[i]];
        }
        return NewObj;
      };

      return history;
    }
  },
  methods: {
    getDrinkProperties: function getDrinkProperties(id) {
      return this.availableDrinks.find(function (obj) {
        return obj.id === id;
      });
    },
    goToMainView: function goToMainView() {
      this.$router.push({ name: 'mainView' });
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


//LocalForage

__webpack_require__(283);
__WEBPACK_IMPORTED_MODULE_1_localforage___default.a.config({
  name: 'waterMind'
});



//Vuetify



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85d03f0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85d03f0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isLoading)?[_vm._v("\n    TRWA ŁADOWANIE...\n  ")]:_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mainView__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_setWeight__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_fullHistory__ = __webpack_require__(339);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'mainView',
    component: __WEBPACK_IMPORTED_MODULE_2__components_mainView__["a" /* default */]
  }, {
    path: '/setWeight',
    name: 'setWeight',
    component: __WEBPACK_IMPORTED_MODULE_3__components_setWeight__["a" /* default */]
    // props: true
  }, {
    path: '/history',
    name: 'fullHistory',
    component: __WEBPACK_IMPORTED_MODULE_4__components_fullHistory__["a" /* default */]
  }]
}));

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainView_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92315ae6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainView_vue__ = __webpack_require__(335);
function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92315ae6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mainView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 291:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 104,
	"./af.js": 104,
	"./ar": 105,
	"./ar-dz": 106,
	"./ar-dz.js": 106,
	"./ar-kw": 107,
	"./ar-kw.js": 107,
	"./ar-ly": 108,
	"./ar-ly.js": 108,
	"./ar-ma": 109,
	"./ar-ma.js": 109,
	"./ar-sa": 110,
	"./ar-sa.js": 110,
	"./ar-tn": 111,
	"./ar-tn.js": 111,
	"./ar.js": 105,
	"./az": 112,
	"./az.js": 112,
	"./be": 113,
	"./be.js": 113,
	"./bg": 114,
	"./bg.js": 114,
	"./bm": 115,
	"./bm.js": 115,
	"./bn": 116,
	"./bn.js": 116,
	"./bo": 117,
	"./bo.js": 117,
	"./br": 118,
	"./br.js": 118,
	"./bs": 119,
	"./bs.js": 119,
	"./ca": 120,
	"./ca.js": 120,
	"./cs": 121,
	"./cs.js": 121,
	"./cv": 122,
	"./cv.js": 122,
	"./cy": 123,
	"./cy.js": 123,
	"./da": 124,
	"./da.js": 124,
	"./de": 125,
	"./de-at": 126,
	"./de-at.js": 126,
	"./de-ch": 127,
	"./de-ch.js": 127,
	"./de.js": 125,
	"./dv": 128,
	"./dv.js": 128,
	"./el": 129,
	"./el.js": 129,
	"./en-au": 130,
	"./en-au.js": 130,
	"./en-ca": 131,
	"./en-ca.js": 131,
	"./en-gb": 132,
	"./en-gb.js": 132,
	"./en-ie": 133,
	"./en-ie.js": 133,
	"./en-il": 134,
	"./en-il.js": 134,
	"./en-nz": 135,
	"./en-nz.js": 135,
	"./eo": 136,
	"./eo.js": 136,
	"./es": 137,
	"./es-do": 138,
	"./es-do.js": 138,
	"./es-us": 139,
	"./es-us.js": 139,
	"./es.js": 137,
	"./et": 140,
	"./et.js": 140,
	"./eu": 141,
	"./eu.js": 141,
	"./fa": 142,
	"./fa.js": 142,
	"./fi": 143,
	"./fi.js": 143,
	"./fo": 144,
	"./fo.js": 144,
	"./fr": 145,
	"./fr-ca": 146,
	"./fr-ca.js": 146,
	"./fr-ch": 147,
	"./fr-ch.js": 147,
	"./fr.js": 145,
	"./fy": 148,
	"./fy.js": 148,
	"./gd": 149,
	"./gd.js": 149,
	"./gl": 150,
	"./gl.js": 150,
	"./gom-latn": 151,
	"./gom-latn.js": 151,
	"./gu": 152,
	"./gu.js": 152,
	"./he": 153,
	"./he.js": 153,
	"./hi": 154,
	"./hi.js": 154,
	"./hr": 155,
	"./hr.js": 155,
	"./hu": 156,
	"./hu.js": 156,
	"./hy-am": 157,
	"./hy-am.js": 157,
	"./id": 158,
	"./id.js": 158,
	"./is": 159,
	"./is.js": 159,
	"./it": 160,
	"./it.js": 160,
	"./ja": 161,
	"./ja.js": 161,
	"./jv": 162,
	"./jv.js": 162,
	"./ka": 163,
	"./ka.js": 163,
	"./kk": 164,
	"./kk.js": 164,
	"./km": 165,
	"./km.js": 165,
	"./kn": 166,
	"./kn.js": 166,
	"./ko": 167,
	"./ko.js": 167,
	"./ky": 168,
	"./ky.js": 168,
	"./lb": 169,
	"./lb.js": 169,
	"./lo": 170,
	"./lo.js": 170,
	"./lt": 171,
	"./lt.js": 171,
	"./lv": 172,
	"./lv.js": 172,
	"./me": 173,
	"./me.js": 173,
	"./mi": 174,
	"./mi.js": 174,
	"./mk": 175,
	"./mk.js": 175,
	"./ml": 176,
	"./ml.js": 176,
	"./mn": 177,
	"./mn.js": 177,
	"./mr": 178,
	"./mr.js": 178,
	"./ms": 179,
	"./ms-my": 180,
	"./ms-my.js": 180,
	"./ms.js": 179,
	"./mt": 181,
	"./mt.js": 181,
	"./my": 182,
	"./my.js": 182,
	"./nb": 183,
	"./nb.js": 183,
	"./ne": 184,
	"./ne.js": 184,
	"./nl": 185,
	"./nl-be": 186,
	"./nl-be.js": 186,
	"./nl.js": 185,
	"./nn": 187,
	"./nn.js": 187,
	"./pa-in": 188,
	"./pa-in.js": 188,
	"./pl": 189,
	"./pl.js": 189,
	"./pt": 190,
	"./pt-br": 191,
	"./pt-br.js": 191,
	"./pt.js": 190,
	"./ro": 192,
	"./ro.js": 192,
	"./ru": 193,
	"./ru.js": 193,
	"./sd": 194,
	"./sd.js": 194,
	"./se": 195,
	"./se.js": 195,
	"./si": 196,
	"./si.js": 196,
	"./sk": 197,
	"./sk.js": 197,
	"./sl": 198,
	"./sl.js": 198,
	"./sq": 199,
	"./sq.js": 199,
	"./sr": 200,
	"./sr-cyrl": 201,
	"./sr-cyrl.js": 201,
	"./sr.js": 200,
	"./ss": 202,
	"./ss.js": 202,
	"./sv": 203,
	"./sv.js": 203,
	"./sw": 204,
	"./sw.js": 204,
	"./ta": 205,
	"./ta.js": 205,
	"./te": 206,
	"./te.js": 206,
	"./tet": 207,
	"./tet.js": 207,
	"./tg": 208,
	"./tg.js": 208,
	"./th": 209,
	"./th.js": 209,
	"./tl-ph": 210,
	"./tl-ph.js": 210,
	"./tlh": 211,
	"./tlh.js": 211,
	"./tr": 212,
	"./tr.js": 212,
	"./tzl": 213,
	"./tzl.js": 213,
	"./tzm": 214,
	"./tzm-latn": 215,
	"./tzm-latn.js": 215,
	"./tzm.js": 214,
	"./ug-cn": 216,
	"./ug-cn.js": 216,
	"./uk": 217,
	"./uk.js": 217,
	"./ur": 218,
	"./ur.js": 218,
	"./uz": 219,
	"./uz-latn": 220,
	"./uz-latn.js": 220,
	"./uz.js": 219,
	"./vi": 221,
	"./vi.js": 221,
	"./x-pseudo": 222,
	"./x-pseudo.js": 222,
	"./yo": 223,
	"./yo.js": 223,
	"./zh-cn": 224,
	"./zh-cn.js": 224,
	"./zh-hk": 225,
	"./zh-hk.js": 225,
	"./zh-tw": 226,
	"./zh-tw.js": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_totalBar_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214be20d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_totalBar_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-214be20d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_totalBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214be20d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_totalBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-text',{staticClass:"px-0 text-xs-center background",style:({ background: 'linear-gradient(90deg, #3775D2 '+_vm.total+'%, #34516d '+_vm.total+'%)' })},[_c('span',{staticClass:"title"},[_c('v-btn',{staticClass:"title",attrs:{"outline":"","flat":""},on:{"click":_vm.goToSetWeight}},[_vm._v("\n            "+_vm._s(_vm.currentState)+"/"+_vm._s(_vm.limit)+"ml\n          ")])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setDefaultDrink_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a3097a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setDefaultDrink_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setDefaultDrink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a3097a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setDefaultDrink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addOwnDrink_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4449c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addOwnDrink_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db4449c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addOwnDrink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4449c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addOwnDrink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},nativeOn:{"click":function($event){return _vm.active($event)}},slot:"activator"},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Dodaj własny...")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"setDefaultDrinkForm",model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-text-field',{attrs:{"label":"Nazwa napoju","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Pojemność napoju","rules":[_vm.rules.required],"required":"","type":"number","min":"0","max":"100000"},model:{value:(_vm.size),callback:function ($$v) {_vm.size=_vm._n($$v)},expression:"size"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","disabled":!_vm.formValid},on:{"click":_vm.saveOwnDrink}},[_vm._v("Dodaj kubek")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editDrink_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256ba067_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editDrink_vue__ = __webpack_require__(327);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-256ba067"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editDrink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256ba067_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editDrink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 326:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-list-tile',{attrs:{"slot":"activator","disabled":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = !_vm.dialog}},slot:"activator"},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Edytuj...")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-snackbar',{attrs:{"timeout":2000,"top":true,"color":"success"},model:{value:(_vm.successSnack),callback:function ($$v) {_vm.successSnack=$$v},expression:"successSnack"}},[_c('span',[_vm._v("Udało się!")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.successSnack = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentEditTemplate.name))])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"setDefaultDrinkForm",model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-text-field',{attrs:{"label":"Nazwa szablonu","type":"text"},model:{value:(_vm.currentEditTemplate.name),callback:function ($$v) {_vm.$set(_vm.currentEditTemplate, "name", $$v)},expression:"currentEditTemplate.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Pojemność (ml)","rules":[_vm.rules.required],"type":"number","min":"0","max":"100000"},model:{value:(_vm.currentEditTemplate.size),callback:function ($$v) {_vm.$set(_vm.currentEditTemplate, "size", _vm._n($$v))},expression:"currentEditTemplate.size"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red"},nativeOn:{"click":function($event){_vm.deleteEditDrinkTemplate(_vm.currentEditTemplate)}}},[_vm._v("Usuń")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","disabled":!_vm.formValid},on:{"click":function($event){_vm.saveEditDrinkTemplate(_vm.currentEditTemplate)}}},[_vm._v("Zapisz")])],1)],1)],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-btn',{attrs:{"slot":"activator","color":"cyan","dark":"","bottom":"","right":"","fixed":"","fab":"","aria-label":"set default drink"},slot:"activator"},[_c('v-icon',[_vm._v("local_drink")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',[_c('v-subheader',[_vm._v("Wybierz napój")]),_vm._v(" "),_c('add-own-drink',{on:{"saveOwnDrink":_vm.saveOwnDrink,"addOwnDrinkActive":_vm.addOwnDrinkActive,"addOwnDrinkSuccess":_vm.addOwnDrinkSuccess}}),_vm._v(" "),_vm._l((_vm.availableDrinksSorted),function(drink,id){return _c('v-list-tile',{key:id,attrs:{"avatar":""},on:{"click":function($event){_vm.setDefaultDrink(drink.id)}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[(drink.id===_vm.defaultDrink.id)?_c('span',[_vm._v("✓")]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("local_drink")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(((drink.name) ? drink.name : drink.size+"ml")))]),_vm._v(" "),(drink.name)?_c('v-list-tile-sub-title',[_vm._v(_vm._s(drink.size)+"ml")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"pr-0 mr-0",attrs:{"icon":"","ripple":""},nativeOn:{"click":function($event){_vm.openEditTemplate(drink)}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1)})],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addDrink_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97edc36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addDrink_vue__ = __webpack_require__(331);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d97edc36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addDrink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97edc36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addDrink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"large":"","fab":"","dark":"","bottom":"","left":"","fixed":"","color":"green","aria-label":"add drink","disabled":(_vm.defaultDrink==null)},on:{"click":_vm.addDrink}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_drunkDrinks_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03167528_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_drunkDrinks_vue__ = __webpack_require__(334);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03167528"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_drunkDrinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03167528_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_drunkDrinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-snackbar',{attrs:{"timeout":2000,"top":true,"color":"success"},model:{value:(_vm.successSnack),callback:function ($$v) {_vm.successSnack=$$v},expression:"successSnack"}},[_c('span',[_vm._v("Udało się!")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.successSnack = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.drinkProperties(_vm.currentClickedDrink.drinkId))?_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[(_vm.drinkProperties(_vm.currentClickedDrink.drinkId))?_c('span',{staticClass:"cutString headline"},[_vm._v("("+_vm._s(_vm.currentClickedDrink.size)+"ml) "+_vm._s(_vm.drinkProperties(_vm.currentClickedDrink.drinkId).name))]):_vm._e()]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Pojemność napoju","type":"number","min":"0","max":"100000","required":""},model:{value:(_vm.currentClickedDrink.size),callback:function ($$v) {_vm.$set(_vm.currentClickedDrink, "size", _vm._n($$v))},expression:"currentClickedDrink.size"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(!_vm.drinkProperties(_vm.currentClickedDrink.drinkId).active),expression:"!drinkProperties(currentClickedDrink.drinkId).active"}],staticClass:"grey--text"},[_vm._v("Szablon tego napoju został usunięty.")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"error"},on:{"click":_vm.deleteEditDialog}},[_vm._v("Usuń")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":_vm.saveEditDialog}},[_vm._v("Zapisz")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',{staticClass:"px-0"},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('transition-group',{attrs:{"name":"list"}},[_vm._l((_vm.drunkHistoryLast),function(drink,id){return _c('v-layout',{key:drink.id,attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pb-0 mb-0",attrs:{"xs4":""}},[_c('v-btn',{attrs:{"outline":"","block":"","color":"indigo","small":"","disabled":""},nativeOn:{"click":function($event){_vm.openEditDialog(drink)}}},[_c('span',[_vm._v(_vm._s(_vm.getOnlyTime(drink.dateTime)))])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-0 mb-0",attrs:{"xs8":""}},[_c('v-btn',{attrs:{"outline":"","block":"","color":"indigo"},nativeOn:{"click":function($event){_vm.openEditDialog(drink)}}},[_c('v-icon',[_vm._v("local_drink")]),_vm._v(" "),_c('span',{staticClass:"cutString"},[_vm._v("("+_vm._s(drink.size)+"ml) "+_vm._s(_vm.drinkProperties(drink.drinkId).name))])],1)],1)],1)}),_vm._v(" "),(_vm.drunkHistory.length > _vm.drunkHistoryLast.length)?_c('v-layout',{key:"last",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pb-0 mb-0",attrs:{"xs4":""}},[_c('v-btn',{attrs:{"outline":"","block":"","color":"indigo","small":"","disabled":""}},[_c('span',[_vm._v("...")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-0 mb-0",attrs:{"xs8":""}},[_c('v-btn',{attrs:{"outline":"","block":"","color":"indigo"},on:{"click":_vm.goToHistory}},[_c('span',[_vm._v("...")])])],1)],1):_vm._e()],2)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('total',{attrs:{"drunkHistory":_vm.getDrunkHistoryToday,"limit":_vm.limit}}),_vm._v(" "),_c('drunk-drinks',{attrs:{"drunkHistory":_vm.getDrunkHistoryToday,"availableDrinks":_vm.availableDrinks,"showLessHistory":_vm.showLessHistory},on:{"saveEditDialog":_vm.saveEditDialog,"deleteEditDialog":_vm.deleteEditDialog}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('add-drink',{attrs:{"defaultDrink":_vm.getDefaultDrinkProps},on:{"addDrink":_vm.addDrink}}),_vm._v(" "),_c('set-default-drink',{attrs:{"availableDrinks":_vm.getActiveAvailableDrinks,"defaultDrink":_vm.getDefaultDrinkProps},on:{"setDefaultDrink":_vm.setDefaultDrink,"addOwnDrink":_vm.addOwnDrink,"saveEditDrinkTemplate":_vm.saveEditDrinkTemplate,"deleteEditDrinkTemplate":_vm.deleteEditDrinkTemplate}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"signature text-xs-center"},[_vm._v("\n    Aby przebyć tysiąc mil, "),_c('br'),_vm._v("trzeba zrobić pierwszy krok.\n    "),_c('p',[_c('router-link',{attrs:{"to":'history'}},[_vm._v("Przejdź do historii")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setWeight_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af6e750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setWeight_vue__ = __webpack_require__(338);
function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af6e750"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_setWeight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af6e750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_setWeight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"text-xs-center":"","fill-height":""}},[_c('v-snackbar',{attrs:{"timeout":60000,"top":true,"color":"success"},model:{value:(_vm.showRedirect),callback:function ($$v) {_vm.showRedirect=$$v},expression:"showRedirect"}},[_c('span',[_vm._v("Zapisałem!")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){return _vm.redirectToMainView($event)}}},[_vm._v("Przejdź dalej")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"mx-auto":""}},[_c('v-card-title',[_c('h1',{staticClass:"headline"},[_vm._v("Personalizacja")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Twoja aktualna waga","type":"number","min":"0","max":"100","disabled":_vm.showRedirect,"rules":[function () { return _vm.errorText==false || _vm.errorText; }]},model:{value:(_vm.myWeightInput),callback:function ($$v) {_vm.myWeightInput=$$v},expression:"myWeightInput"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Wzmożony wysiłek","hint":((_vm.settings.sport)?'+200ml':'-200ml'),"disabled":_vm.showRedirect},model:{value:(_vm.settings.sport),callback:function ($$v) {_vm.$set(_vm.settings, "sport", $$v)},expression:"settings.sport"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Słoneczna pogoda","hint":((_vm.settings.sunny)?'+200ml':'-200ml'),"disabled":_vm.showRedirect},model:{value:(_vm.settings.sunny),callback:function ($$v) {_vm.$set(_vm.settings, "sunny", $$v)},expression:"settings.sunny"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('small',{staticClass:"grey--text"},[_vm._v("Każdy kilogram masy ciała, wymaga wypicia 40ml płynu dziennie.")])])],1)],1),_vm._v(" "),_c('v-card-title',[_c('h1',{staticClass:"headline"},[_vm._v("Ustawienia")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Skracaj listę wypitych napojów","hint":"Po zaznaczeniu, lista dzisiejszych napojów będzie skracana do 4 ostatnich.","persistent-hint":"","disabled":_vm.showRedirect},model:{value:(_vm.settings.lessHistory),callback:function ($$v) {_vm.$set(_vm.settings, "lessHistory", $$v)},expression:"settings.lessHistory"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRedirect),expression:"!showRedirect"}],attrs:{"color":"black","flat":""},on:{"click":_vm.redirectToMainView}},[_vm._v("Anuluj")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showRedirect),expression:"!showRedirect"}],attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.setWeight(_vm.myWeightInput)}}},[_vm._v("Zapisz")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRedirect),expression:"showRedirect"}],attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.redirectToMainView}},[_vm._v("Przejdź dalej")])],1)],1),_vm._v(" "),_c('small',{staticClass:"grey--text"},[_vm._v("wersja 1.3")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullHistory_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6157ba29_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullHistory_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(22)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6157ba29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fullHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6157ba29_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fullHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":""},on:{"click":_vm.goToMainView}},[_c('v-icon',[_vm._v("arrow_back")]),_vm._v(" "),_c('span',[_vm._v("Wróć do widoku głównego")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("Historia")]),_vm._v(" "),_c('span',{staticClass:"grey--text"},[_vm._v("Widok napojów z ostatniego miesiąca.")])])]),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.historyParsed),function(propValue,propName,index){return [_c('v-subheader',{key:index},[_vm._v(_vm._s(propName))]),_vm._v(" "),_vm._l((propValue),function(historyItem,historyIndex){return _c('v-list-tile',{key:historyIndex+'history'+historyItem.id,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("local_drink")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.getDrinkProperties(historyItem.drinkId).name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(historyItem.size)+"ml")])],1)],1)})]})],2)],1),_vm._v(" "),_c('v-card-actions')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[279]);


// WEBPACK FOOTER //
// static/js/app.2df3d7f3cf5efc1a7331.js